import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CreateBoatPage } from "./create-boat.page";

const routes: Routes = [
  {
    path: "",
    component: CreateBoatPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateBoatPageRoutingModule {}
